export default "__VITE_ASSET__B5rP5Dct__"